import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { BookingsSectionTitle } from "./styles";
import { Form } from "antd";
import { useState } from "react";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const AuditLogInformation = ({ formData }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  return (
    <>
      <FieldSecurityProvider
        entity={SCHEMA_NAME.SYSTEM_AUDIT_LOG}
        startingPoint="Audit-log"
        bookingsFieldsEnabled={!isDisabled}
      >
        <Form disabled={isDisabled} initialValues={formData}>
          <StyledGridRow gutter={16}>
            <StyledGridCol span={5}>
              <SecureFormItem
                fieldName="action"
                formItemProps={{ name: "action", label: "Action" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={5}>
              <SecureFormItem
                fieldName="appContext"
                formItemProps={{ name: "appContext", label: "Module" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={4}>
              <SecureFormItem
                fieldName="moduleID"
                formItemProps={{ name: "moduleID", label: "Module ID" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={5}>
              <SecureFormItem
                fieldName="rootAppContext"
                formItemProps={{
                  name: "rootAppContext",
                  label: "Root AppContext",
                }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={5}>
              <SecureFormItem
                fieldName="recordNumber"
                formItemProps={{ name: "recordNumber", label: "Record #" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={16}>
            <StyledGridCol flex="auto">
              <SecureFormItem
                fieldName="fullFieldSource"
                formItemProps={{ name: "fullFieldSource", label: "Table Path" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol>
              <SecureFormItem
                fieldName="appContextKeyFieldID"
                formItemProps={{
                  name: "appContextKeyFieldID",
                  label: "Table ID",
                }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={16}>
            <StyledGridCol span={24}>
              <SecureFormItem
                fieldName="extraText"
                formItemProps={{ name: "extraText", label: "Extra Text" }}
              >
                <TextField
                  rows="6"
                  inputType="textarea"
                  style={{
                    backgroundColor: isDisabled ? "#f5f5f5" : "",
                    color: isDisabled ? "#a0a0a0" : "",
                  }}
                />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>

          <BookingsSectionTitle>
            <span>Audit Log Administrative Information</span>
          </BookingsSectionTitle>

          <StyledGridRow gutter={16}>
            <StyledGridCol span={4}>
              <SecureFormItem
                fieldName="systemAuditLogID"
                formItemProps={{ name: "systemAuditLogID", label: "ID" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="dateAdded"
                formItemProps={{ name: "dateAdded", label: "Date Entered" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={4}>
              <SecureFormItem
                fieldName="timeAdded"
                formItemProps={{ name: "timeAdded", label: "Time Entered" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol span={6}>
              <SecureFormItem
                fieldName="user"
                formItemProps={{ name: "user", label: "User" }}
              >
                <TextField />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </FieldSecurityProvider>
    </>
  );
};
export default AuditLogInformation;
